import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { configs } from "configs"
import { getDeviceInoHash } from "configs/utils"
import { LOGIN_STORAGE_KEY } from "constants"
import { API_URLS, AUTH_TOKEN_COOKIE_KEY } from "constants/api"
import { t } from "i18next"
import { getHeaders } from "store/parentApi"
import { getCookie, setCookie } from "utils/cookie"
import { inDevelopMode } from "utils/env"
import { setStorageItem } from "utils/localStorage"

const authHeader = auth => ({
  ["Authorization"]: auth ? `Bearer ${auth}` : `Bearer ${getCookie(AUTH_TOKEN_COOKIE_KEY)}`,
})
const transformErrorResponse = error => {
  const errorMessage = error?.data?.errors?.map(obj => obj?.message).join("\n") || t("Something went wrong")
  return {
    status: error?.status || error?.originalStatus,
    message: errorMessage,
  }
}

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: configs.apiBaseURL(),
    ...getHeaders(),
    credentials: inDevelopMode ? undefined : "include",
    // Custom error handling
    async fetchBaseQueryError(error) {
      if (error.status === 404) {
        // Handle a 404 error
        throw new Error("Resource not found") // Throw custom error
      }

      // Add more error checks as necessary
      if (error.status === 500) {
        throw new Error("Server error. Please try again later.")
      }

      // If there are other status codes, throw the error
      throw error // Rethrow other errors
    },
  }),

  endpoints: builder => ({
    otpLogin: builder.mutation({
      query: body => ({
        url: "/otpLogin",
        method: "POST",
        body,
      }),
      transformErrorResponse,
    }),
    verifyOtp: builder.mutation({
      query: body => ({
        url: API_URLS.VERIFY_OTP,
        method: "POST",
        body,
      }),
      transformErrorResponse,
    }),
    authorizeUser: builder.mutation({
      query: body => ({
        url: API_URLS.AUTHORIZE_USER,
        method: "POST",
        body,
      }),
      transformErrorResponse,
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            setStorageItem(LOGIN_STORAGE_KEY, "yes")
          }
        } catch (err) {}
      },
    }),
  }),
})

export const { useOtpLoginMutation, useVerifyOtpMutation, useAuthorizeUserMutation } = authApi
